export default __webpack_public_path__ + "static/David Rajec Resume-23c5e896508fa508be6d7bedfdfae203.pdf";